import { useState, useCallback } from 'react';
import toolboxApiService from '../services/toolboxApiService';

function useToolboxData() {
  const [tipoOperativos, setTipoOperativos] = useState([]);
  const [lugares, setLugares] = useState([]);
  const [participantes, setParticipantes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const cargarTipoOperativos = useCallback(async () => {
    try {
      const data = await toolboxApiService.getTipoOperativos();
      setTipoOperativos(data);
    } catch (err) {
      setError(err.message);
    }
  }, []);

  const cargarLugares = useCallback(async (tipoOperativo) => {
    setLugares([]);
    if (!tipoOperativo) return;
    try {
      const data = await toolboxApiService.getLugares(tipoOperativo);
      setLugares(data);
    } catch (err) {
      setError(err.message);
    }
  }, []);

  const buscarParticipantes = useCallback(async (filtros) => {
    setLoading(true);
    setError(null);
    setParticipantes([]);
    try {
      const data = await toolboxApiService.getParticipantes(filtros);
      const mapped = data.map((p) => ({
        id: p.legajo,
        nombre: p.nombre,
        legajo: p.legajo,
      }));
      setParticipantes(mapped);
      return mapped;
    } catch (err) {
      setError(err.message);
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    tipoOperativos,
    lugares,
    participantes,
    loading,
    error,
    cargarTipoOperativos,
    cargarLugares,
    buscarParticipantes,
  };
}

export default useToolboxData;
